/* eslint-disable react-hooks/exhaustive-deps */
import { getReadableFormatNumber, numberToCommas } from "@/lib/utils/StringUtility";
import React from "react";
import { ActiveCardProps, LoadingStateProps } from "@/types/types.d";
import { SummaryCard } from "../../../Cards/SummaryCard";

type Props = {
  activeCard: ActiveCardProps;
  loading: LoadingStateProps;
  data: any;
  comparisonData: any;
  query: any;
  period: any;
  prevPeriod: any;
  comparisonPeriod?: any;
};

const UniqueConversions = ({
  activeCard,
  loading,
  data,
  comparisonData,
  query,
  period,
  prevPeriod,
  comparisonPeriod
}: Props) => {
  const getComparisonPercentageDiff = () => {
    const percentageChange =
      ((data.unique_conversions - comparisonData.unique_conversions) /
        comparisonData.unique_conversions) *
      100;
    return Math.round(percentageChange);
  };

  return (
    <div data-cy="events-card">
      <SummaryCard
        cursor="cursor-default"
        activeCard={activeCard}
        title={"Unique Conversions"}
        onClick={() => {}}
        uniquekey={"unique_conversions"}
        card={"unique_conversions"}
        value={getReadableFormatNumber(data.unique_conversions)}
        tooltip={`${numberToCommas(data.unique_conversions)} Unique Conversions`}
        runningDiff={data.unique_conversions_diff}
        runningDiffTooltip={`${data.unique_conversions_diff}% ${
          data.unique_conversions_diff > 0 ? "increase" : "decrease"
        } in unique conversions from previous period ${
          comparisonPeriod ? comparisonPeriod : prevPeriod
        } `}
        loading={loading}
        showRunningDiff={query?.period !== "live"}
        comparison={query?.comparison}
        comparisonPercentageDiff={getComparisonPercentageDiff()}
      />
    </div>
  );
};
const UniqueConversionsMemoized = React.memo(UniqueConversions);
export { UniqueConversionsMemoized as UniqueConversions };
